module.exports = __webpack_public_path__ + "images/emoji/person_with_blond_hair.4a96bd13c8004965cf8c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/person_with_blond_hair.png
// module id = eYC7
// module chunks = 24